import {
  Checkbox as ChakraCheckbox,
  CheckboxProps,
  FormControl,
  FormErrorMessage,
} from '@chakra-ui/react';
import {
  FieldErrors,
  FieldValues,
  Path,
  UseFormRegister,
} from 'react-hook-form';

interface CheckboxPrimaryProps<TFields extends FieldValues = FieldValues>
  extends CheckboxProps {
  name: Path<TFields>;
  label?: string;
  register: UseFormRegister<TFields>;
  errors?: FieldErrors<TFields>;
}

export function Checkbox<TFields extends FieldValues = FieldValues>({
  name,
  label,
  value,
  children,
  errors,
  register,
  ...props
}: CheckboxPrimaryProps<TFields>) {
  const isInvalid = errors ? !!errors[name] : false;
  const errorMessage = errors ? errors[name]?.message : '';

  return (
    <FormControl id={props.id} isInvalid={isInvalid}>
      <ChakraCheckbox
        value={value}
        aria-label={label}
        {...register(name)}
        {...props}
      >
        {label}
        {children}
      </ChakraCheckbox>
      <FormErrorMessage>{errorMessage as string}</FormErrorMessage>
    </FormControl>
  );
}

export default Checkbox;
